module.exports = __webpack_public_path__ + "img/case-lg-4.f09211e7.jpg";